import {
  type CopyParams,
  EntityEditHandler,
} from '@/plugins/cad/module/CADModule/edit/EntityEditHandler'
import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { Command } from '@/plugins/cad/module/core/Command'

/**
 * 复制实体命令，按平移/偏移参数生成副本并加入视图，支持撤销/重做。
 */
export class CopyEntityCommand extends Command {
  private entities: IEntity[]
  private copyEntities: IEntity[] = []
  private params: CopyParams
  private viewManager: CADViewManager

  constructor(entities: IEntity[], params: CopyParams, viewManager: CADViewManager) {
    super()
    this.entities = entities
    this.params = params
    this.viewManager = viewManager
  }

  /** 生成副本并加入视图 */
  execute(): void {
    this.copyEntities = EntityEditHandler.copy(this.entities, this.params)
    this.viewManager.addEntities(this.copyEntities)
  }

  /** 撤销：删除已生成的副本 */
  undo(): void {
    this.viewManager.deleteEntities(this.copyEntities)
  }

  /** 重做：重新加入已生成的副本 */
  redo(): void {
    this.viewManager.addEntities(this.copyEntities)
  }
}
